import { SDKConfig } from '../types';
import { DEFAULT_BASE_URL } from '../utils/api';

export class AdsManager {
  private apiKey: string;
  private baseURL: string;

  constructor(config: SDKConfig) {
    this.apiKey = config.apiKey;
    this.baseURL = config.baseURL || DEFAULT_BASE_URL;
  }

  async getAds() {
    try {
    //   const result = await fetch(`${this.baseURL}/ads`, {
    //     method: 'GET',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'X-API-Key': this.apiKey
    //     }
    //   });

    //   const response = await result.json();

    //   if (!response.success) {
    //     throw new Error(response.error || 'Failed to fetch ads');
    //   }

     // return response.ads;
      //---remove this code after testing
      const adv_creative = {
        creative: [
          {
            creative_id:1,
            icon: "https://example.com/icons/video-icon.png",
            title: "Watch an ad today 📺",
            description: "Watch an ad and earn. It's that simple.",
            rewardContent: "1 coins",
            clickTaskTrackingUrl: "https://adnetwork.com/v?id=[taskid]",
            redirectlink: "https://adnetwork.com/c?id=[taskid]"
          }
        ]
      };
    
      return adv_creative;
       //---remove this code after testing END

    } catch (error) {
      throw new Error(`Failed to fetch ads: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  async showAd(adId: string) {
    try {
      const result = await fetch(`${this.baseURL}/ads/${adId}/show`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': this.apiKey
        }
      });

      const response = await result.json();
      return response.success;
    } catch (error) {
      throw new Error(`Failed to show ad: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}